module.exports = __webpack_public_path__ + "img/coupon_zhTc.f62e0af3.png";